module.exports = __webpack_public_path__ + "static/media/card-2.11d1dc72.jpf";